import { Sparkles } from "lucide-react";

export function CalendarSidebarExtra() {
  return (
    <aside className="bg-card border border-border rounded-2xl p-5 shadow-sm">
      <div className="flex items-center gap-2 mb-3">
        <div className="h-8 w-8 rounded-xl bg-gradient-to-br from-[hsl(225_85%_56%)] to-[hsl(228_80%_48%)] flex items-center justify-center">
          <Sparkles className="h-4 w-4 text-white" />
        </div>
        <div>
          <div className="text-sm font-semibold text-foreground">Painel rápido</div>
          <div className="text-[11px] text-muted-foreground">Calendário</div>
        </div>
      </div>
      <div className="rounded-xl border border-dashed border-border bg-muted/30 p-4 text-center">
        <p className="text-xs text-muted-foreground leading-relaxed">
          Mais funcionalidades em breve.
          <br />
          <span className="opacity-70">Mini-calendário, próximos eventos e filtros.</span>
        </p>
      </div>
    </aside>
  );
}